(() => {
  const normalize = value => value.toLocaleLowerCase('fr').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  document.querySelectorAll('[data-fyp-catalogue]').forEach(root => {
    const items = [...root.querySelectorAll('[data-fyp-subjects]')].map(el => ({el, subjects: el.dataset.fypSubjects.split(' '), text: normalize(el.dataset.fypTitle + ' ' + el.dataset.fypSearch)}));
    const buttons = [...root.querySelectorAll('[data-fyp-filter]')];
    const input = root.querySelector('#FypCatalogueSearch');
    let selected = 'all';
    function update() {
      const words = normalize(input.value.trim()).split(/\s+/).filter(Boolean);
      let count = 0;
      items.forEach(item => { const visible = (selected === 'all' || item.subjects.includes(selected)) && words.every(word => item.text.includes(word)); item.el.hidden = !visible; if (visible) count++; });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fypFilter === selected)));
      root.querySelector('[data-fyp-count]').textContent = count;
      const countLabel = root.querySelector('[data-fyp-count-label]');
      countLabel.textContent = count === 1 ? countLabel.dataset.singular : countLabel.dataset.plural;
      root.querySelector('[data-fyp-empty]').hidden = count !== 0;
    }
    function readHash() { const hash = location.hash.slice(1); selected = buttons.some(b => b.dataset.fypFilter === hash) ? hash : 'all'; update(); }
    buttons.forEach(button => button.addEventListener('click', () => { selected = button.dataset.fypFilter; if (location.protocol !== 'about:') history.replaceState(null, '', '#' + selected); update(); }));
    input.addEventListener('input', update);
    root.querySelector('[data-fyp-reset]').addEventListener('click', () => { input.value = ''; selected = 'all'; if (location.protocol !== 'about:') history.replaceState(null, '', '#all'); update(); input.focus(); });
    window.addEventListener('hashchange', readHash);
    readHash();
  });
})();
